import React from "react";
import { PhoenixAppButton } from "src/Components/UI/Phoenix";
import { IntegrationItem } from "src/types/StateTypes";

const LearnMoreButton = ({ integration }: { integration: IntegrationItem }) => {
  return (
    <PhoenixAppButton
      buttonType="ghost-small"
      variant="brand"
      onClick={() => {
        window.open(integration.learnMoreUrl, "_blank");
      }}
    >
      Learn More
    </PhoenixAppButton>
  );
};

export default LearnMoreButton;
